module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/73AuWr/tc-custom/9781452123622.jpg?1726871162723",
      "alt": "This image is the cover for the book Big Book of Chicken"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Big Book of Chicken\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The beloved cookbook author shares more than 275 classic and creative chicken dishes in this easy-to-use volume.")]), _c('br'), _c('br'), _vm._v("Whether it’s roasted, fried, grilled, broiled, braised, sautéed, or baked, chicken is always delicious. Maryana Vollstedt has created a new addition to her popular "), _c('i', [_vm._v("Big Book")]), _vm._v(" series with this glorious homage to everyone’s favorite fowl. "), _c('i', [_vm._v("The Big Book of Chicken")]), _vm._v(" offers a tremendous variety, from creative recipes like Pomegranate-Molasses Chicken Drummettes and Chipotle Cheddar Chicken Corn Chowder to comforting favorites like Chicken Marsala and Old-Fashioned Fried Chicken. "), _c('br'), _c('br'), _vm._v("Every recipe is simple to follow with lots of helpful tips on identifying parts of the chicken, cutting up and storing it, and safe preparation techniques. With more than 275 recipes inspired from cuisines around the world, this big book serves up everything there is to know about chicken.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maryana Vollstedt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Maryana Vollstedt has written several Chronicle cookbooks in the Big Book series. She lives in Eugene, Oregon.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0